declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', '2123502428447172')
  window.fbq('track', 'PageView')
}

export function trackPurchase() {
  if (window.fbq) {
    window.fbq('track', 'Purchase')
  }
}
